module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/service-image--sp-33eb3d4b0499287219176ef257a53b35.png";